var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"description":_vm.description}},[_c('b-form-input',{attrs:{"type":_vm.type,"min":_vm.min,"placeholder":_vm.placeholder,"trim":""},on:{"input":(data) => { _vm.$emit('input', data) }},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }